import { Component, inject } from '@angular/core';

import { GlobalSpinnerService } from './global-spinner.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { IconComponent } from '../icon/icon.component';
import { MarkdownItPipe } from '../../pipes/markdown-it.pipe';

@Component({
    selector: 'ca-global-spinner',
    templateUrl: './global-spinner.component.html',
    styleUrls: ['./global-spinner.component.scss'],
    imports: [MatProgressSpinner, MatButton, AsyncPipe, TranslatePipe, IconComponent, MarkdownItPipe]
})
export class GlobalSpinnerComponent {
    public globalSpinnerService = inject(GlobalSpinnerService);
}
